export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-calculator-line',
      title: '無駄の完全排除',
      description: 'PP単価を0.1円単位で最適化。不要な支出を徹底的に削減します。'
    },
    {
      icon: 'ri-time-line',
      title: '時間の節約',
      description: '情報収集・比較検討の時間を削減。あなたは実行に集中できます。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '心理的安心',
      description: '制度変更リスクを織り込んだ設計。途中で計画が崩れる不安を解消。'
    }
  ];

  const suitable = [
    '効率的に修行を完了したい',
    '制度変更に柔軟に対応したい',
    '実績のある方法で確実に達成したい',
    '時間をかけずに最適解を知りたい'
  ];

  const notSuitable = [
    '自分で全て調べて実行したい',
    '最終的な費用は気にしない',
    'サポート費用は払いたくない',
    '失敗しても経験だと割り切れる'
  ];

  return (
    <>
      <section className="py-28 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                  <i className={`${benefit.icon} text-6xl text-[#0D47A1]`}></i>
                </div>
                <h3 className="text-2xl font-semibold text-[#1A2B4A] mb-4">{benefit.title}</h3>
                <p className="text-[15px] leading-relaxed text-[#5A5A5A]">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-28 px-6 bg-[#F5F5F3]">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-bold text-[#1A2B4A] text-center mb-16">
            このサービスが向いている方・向いていない方
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            {/* Suitable */}
            <div className="bg-[#E8F5E9] border-2 border-[#4CAF50] rounded-2xl p-10">
              <h3 className="text-xl font-semibold text-[#2E7D32] mb-6">向いている方</h3>
              <div className="space-y-4">
                {suitable.map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-xl text-[#4CAF50]"></i>
                    </div>
                    <p className="text-[15px] text-[#2C2C2C]">{item}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Not Suitable */}
            <div className="bg-[#FFEBEE] border-2 border-[#F44336] rounded-2xl p-10">
              <h3 className="text-xl font-semibold text-[#C62828] mb-6">向いていない方</h3>
              <div className="space-y-4">
                {notSuitable.map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-close-line text-xl text-[#F44336]"></i>
                    </div>
                    <p className="text-[15px] text-[#2C2C2C]">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
